// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted

/**
 * Whether two string lists hold the same values in the same order.
 *
 * Pairs with `useStableValue` for the selection arrays callers pass as fresh
 * literals on every render.
 */
export function isSameStringList(previous: string[], next: string[]): boolean {
  return (
    previous.length === next.length &&
    previous.every((value, index) => value === next[index])
  );
}
